/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2021. All rights reserved
------------------------------------------------------------------------------------------------- */
import { css } from 'lit-element';

export const sliderStyles = css`
  :host {
    width: 100%;
    outline: 0;
    display: block;
  }
  :host([vertical]) {
    width: fit-content;
    width: -moz-fit-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  :host([vertical][right]) {
    float: right;
  }

  :host([show-range]) #inputText {
    display: none;
  }

  :host([vertical][show-controls]) .vertical-slider-wrapper {
    height: calc(100% - 4rem);
  }

  :host([vertical][direction-toggle]) .vertical-slider-wrapper,
  :host([vertical][direction-toggle][show-controls]) arrow-controls {
    transform: rotate(180deg);
  }

  :host([vertical][direction-toggle][show-controls]) arrow-controls {
    transform-style: preserve-3d;
  }

  :host([vertical][show-controls][show-value]) .vertical-slider-wrapper {
    height: calc(100% - 7.5rem);
  }

  :host([vertical][show-value]) .vertical-slider-wrapper {
    height: calc(100% - 4rem);
  }

  :host .outer-wrapper {
    position: relative;
    display: flex;
  }

  :host .sliderWrapper {
    position: relative;
    width: 100%;
    height: 2rem;
    outline: none;
    display: flex;
  }

  :host([show-controls]) .sliderWrapper {
    width: calc(100% - 4rem);
  }

  :host([vertical]) .verticalTrack {
    height: 0.125rem;
    width: 100%;
    position: relative;
    display: flex;
    outline: none;
    margin: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: rgba(var(--ui-1), var(--opacity-6));
    opacity: unset;
    left: 0;
    right: 0;
    border: 0;
  }

  :host(.touch-device[vertical]) .verticalTrack {
    transform: rotate(0deg);
  }

  :host([vertical]) #inputLabel input {
    width: 50% !important;
    background: transparent;
    border: none;
    text-align: right;
    font: var(--body-1);
    line-height: 1rem;
    height: 1rem;
    padding: 0;
    outline: none;
    color: var(--text-secondary);
    -moz-appearance: textfield;
  }

  :host([vertical]) #inputLabel input:focus {
    width: 100% !important;
  }

  input[type='range']::-webkit-slider-thumb {
    box-shadow: none;
  }

  .sliderTrack::-webkit-slider-thumb,
  .verticalTrack::-webkit-slider-thumb {
    appearance: none;
    position: relative;
    width: 0.875rem;
    height: 0.875rem;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    outline: 0;
    z-index: 1;
    background: rgba(var(--ui-5), var(--opacity-1));
    -webkit-appearance: none;
    user-select: none;
    -webkit-user-select: none;
  }

  :host(.touch-device) .sliderTrack::-webkit-slider-thumb,
  :host(.touch-device) .verticalTrack::-webkit-slider-thumb {
    background-clip: padding-box;
    border: 0.8125rem solid rgba(0, 0, 0, 0);
    box-sizing: unset;
  }

  :host(.touch-device) .sliderTrack::-webkit-slider-runnable-track,
  :host(.touch-device) .verticalTrack::-webkit-slider-runnable-track {
    margin-left: -0.8125rem;
    margin-right: -0.8125rem;
  }

  .sliderTrack::-webkit-slider-runnable-track,
  .verticalTrack::-webkit-slider-runnable-track {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-track,
  .verticalTrack::-moz-range-track {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-progress,
  .verticalTrack::-moz-range-progress {
    cursor: pointer;
  }

  .sliderTrack::-moz-range-thumb,
  .verticalTrack::-moz-range-thumb {
    position: relative;
    width: 0.875rem;
    height: 0.875rem;
    cursor: pointer;
    border-radius: 50%;
    border: none;
    z-index: 1;
    background: rgba(var(--ui-5), var(--opacity-1));
  }

  .sliderTrack::-moz-range-thumb,
  .verticalTrack::-moz-range-thumb {
    transform: translateZ(0);
  }

  :host(:not(.touch-device)) .sliderTrack::-webkit-slider-thumb:hover,
  :host(:not(.touch-device)) .verticalTrack::-webkit-slider-thumb:hover {
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host(:not(.touch-device)) .active.sliderTrack::-webkit-slider-thumb,
  :host(:not(.touch-device)) .active.verticalTrack::-webkit-slider-thumb,
  :host .active.sliderTrack::-webkit-slider-thumb,
  :host .active.verticalTrack::-webkit-slider-thumb {
    background-color: rgba(var(--ui-3), var(--opacity-1));
  }

  :host(.touch-device) .active.sliderTrack::-webkit-slider-thumb,
  :host(.touch-device) .active.verticalTrack::-webkit-slider-thumb {
    border: 0.8125rem solid rgba(var(--ui-3), var(--opacity-5));
  }

  :host(:not(.touch-device)) .sliderTrack::-moz-range-thumb:hover,
  :host(:not(.touch-device)) .verticalTrack::-moz-range-thumb:hover {
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  .sliderTrack::-moz-range-thumb:active,
  .verticalTrack::-moz-range-thumb:active {
    background: rgba(var(--ui-3), var(--opacity-1));
  }

  .sliderTrack::-webkit-slider-thumb:active,
  .verticalTrack::-webkit-slider-thumb:active {
    background: rgba(var(--ui-3), var(--opacity-1));
  }
  :host(:not(.touch-device)) .active.sliderTrack::-moz-range-thumb,
  :host(:not(.touch-device)) .active.verticalTrack::-moz-range-thumb,
  :host .active.sliderTrack::-moz-range-thumb,
  :host .active.verticalTrack::-moz-range-thumb {
    background: rgba(var(--ui-3), var(--opacity-1));
  }

  :host([vertical]) #inputLabel span {
    width: 50%;
    font: var(--body-1);
    line-height: 1rem;
    height: 1rem;
    color: rgba(var(--ui-1), var(--opacity-5));
    margin-left: 0.125rem;
  }

  :host .sliderTrack {
    width: 100%;
    height: 0.125rem;
    outline: 0;
    background-color: rgba(var(--ui-1), var(--opacity-6));
    position: absolute;
    -moz-appearance: none;
    -webkit-appearance: none;
    margin: 0.9375rem 0 0 0;
    opacity: unset;
    border: 0;
  }

  /* common styles */
  .label-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .slider-label {
    flex: 1 1 auto;
    min-width: 3.375rem;
    font: var(--body-1);
    line-height: 1.5rem;
    font-weight: normal;
    color: var(--text-secondary);
    -webkit-font-smoothing: antialiased !important;
    text-rendering: optimizeLegibility !important;
    -moz-osx-font-smoothing: grayscale !important;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: 0.2s all ease-in-out;
  }

  :host(:not([vertical])) .slider-label {
    padding-right: 0.5rem;
  }

  :host([vertical]) .slider-label {
    text-align: center;
  }

  .label-wrapper input {
    display: none;
    outline: 0;
    border: none;
    width: 2.5rem;
    height: 1.5rem;
    font: var(--body-1);
    line-height: 1.5rem;
    color: var(--text-secondary);
    background: rgba(var(--ui-1), var(--opacity-7));
    border-radius: 0.125rem;
    box-sizing: border-box;
    padding: 0.25rem;
    transition: 0.2s all ease-in-out;
    text-align: center;
    -moz-appearance: textfield;
  }

  input::-webkit-inner-spin-button {
    display: none;
  }

  :host(:not([label])) .label-wrapper {
    display: none;
  }

  :host([show-value]) .label-wrapper input {
    display: inline-flex;
  }

  :host([show-value][vertical]) .label-wrapper input {
    display: none;
  }

  :host(:not([show-value])[vertical]) .label-wrapper {
    padding-bottom: 1rem;
  }

  /* Disabled Styles */
  :host([disabled]) {
    pointer-events: none;
  }

  :host([disabled]) ::-webkit-slider-thumb {
    background: rgba(var(--ui-6), var(--opacity-1));
  }

  :host([disabled]) ::-moz-range-thumb {
    background: rgba(var(--ui-6), var(--opacity-1));
  }

  :host([disabled]) #verticalSlider,
  :host([disabled]) #horizontalSlider {
    background: rgb(var(--ui-1), var(--opacity-7));
  }

  :host([disabled]) .slider-label,
  :host([disabled]) .label-wrapper input {
    color: var(--text-disabled);
    opacity: unset;
  }

  :host([disabled]) .tick-item,
  :host(.touch-device[vertical][disabled]) .tick-item:after {
    background: rgba(var(--ui-1), var(--opacity-4));
  }

  :host([disabled]) #verticalInput {
    color: var(--text-disabled) !important;
    opacity: unset;
  }

  /* Adjustment controls styles */
  :host([show-controls]:not([vertical])) arrow-controls {
    position: absolute;
    right: 0;
    top: -0.0625rem;
  }

  :host([show-controls][vertical]) arrow-controls {
    flex-direction: column;
    min-height: 4rem;
  }

  /* Tooltip styles */
  #verticalTooltip,
  #sliderTooltip {
    display: none;
    position: absolute;
    pointer-events: none;
    outline: 0;
    width: 2.5rem;
    height: 1.5rem;
    font: var(--body-1);
    text-align: center;
    color: var(--text-secondary);
    background: var(--base-3);
    box-shadow: var(--shadow-raised);
    border-radius: 0.125rem;
    box-sizing: border-box;
    padding: 0.25rem;
    z-index: 5;
  }

  :host .tick-item {
    cursor: pointer;
    border-radius: 50%;
    outline: 0;
    background: rgba(var(--ui-1), var(--opacity-1));
    margin-top: 0.625rem;
    -moz-appearance: none;
    -webkit-appearance: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(.touch-device[vertical]) .tick-item {
    background: transparent;
  }

  .ticks-list {
    position: absolute;
    height: fit-content;
    height: -moz-fit-content;
    margin: 0;
    padding: 0;
    margin: 0 auto;
    top: 1rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.2s ease-in-out;
  }

  :host([vertical]) .ticks-list {
    top: unset;
  }

  .ticks-list li {
    height: 0.375rem;
    width: 0.375rem;
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
    margin: 0 !important;
  }

  :host(.touch-device[vertical]) .ticks-list li:after {
    content: '';
    position: absolute;
    height: 0.375rem;
    width: 0.375rem;
    z-index: -1;
    outline: 0;
    border-radius: 50%;
    margin: 0 !important;
    background: rgba(var(--ui-1), var(--opacity-1));
    margin-top: 0.625rem;
  }

  :host(:not(.touch-device)) .ticks-list li:hover {
    height: 0.5rem;
    width: 0.5rem;
    background: rgba(var(--ui-0), var(--opacity-1));
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
  }

  .ticks-list li:active {
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(:not([show-value])) #inputLabel {
    display: none;
  }

  #inputLabel {
    background-color: rgba(var(--ui-1), var(--opacity-7));
    border-radius: 0.125rem;
    margin: auto;
    margin-bottom: 1rem;
    max-width: 4.5rem;
    min-width: 3.5rem;
    display: inline-flex;
    padding: 0.25rem;
    box-sizing: border-box;
    vertical-align: middle;
  }

  :host(:not([vertical])) #inputLabel {
    display: none;
  }

  #verticalTooltip {
    top: -0.5rem;
    left: 1.5rem;
    transform: rotate(-90deg);
    margin-top: -2.1875rem;
  }

  #sliderTooltip {
    margin: -1.375rem;
  }

  :host([vertical][right]) #verticalTooltip {
    top: 3.5rem;
  }

  :host([vertical][direction-toggle]) #verticalTooltip {
    top: 3.5rem;
    transform: rotate(90deg);
  }

  :host([vertical][right][direction-toggle]) #verticalTooltip {
    bottom: 3.5rem;
    top: -0.5rem;
  }

  :host(:not([show-value]):hover:not(.touch-device)) #sliderTooltip,
  :host(:not([show-value]):hover:not(.touch-device)) #verticalTooltip,
  #label-wrapper.hover #sliderTooltip {
    display: block;
  }

  :host .ticks_collision::-webkit-slider-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .ticks_collision::-webkit-slider-thumb:hover {
    background-color: rgba(var(--ui-2), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .active.ticks_collision::-webkit-slider-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host .ticks_collision::-moz-range-thumb {
    background-color: rgba(var(--ui-0), var(--opacity-1)) !important;
  }

  :host(:not(.touch-device)) .ticks_collision::-moz-range-thumb:hover {
    background-color: rgba(var(--ui-2), var(--opacity-1)) !important;
  }

  :host .sh-step-thumb-item {
    cursor: pointer;
    outline: 0;
    background: rgba(var(--ui-1), var(--opacity-6));
    -moz-appearance: none;
    -webkit-appearance: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
  }

  :host(.touch-device[vertical]) .tick_collision_z,
  :host(.touch-device[vertical]) .sh-step-thumb-item {
    z-index: -1;
  }

  :host([vertical]) .step_ticks {
    top: unset;
  }

  .step_ticks {
    position: absolute;
    padding: 0;
    margin: 0 auto;
    top: 1.03125rem;
    display: none;
    flex-direction: row;
    align-items: center;
  }

  .step_ticks li {
    height: 0.5rem;
    width: 0.0625rem;
    -moz-user-select: none;
    -webkit-user-select: none;
    list-style: none;
    position: absolute;
  }

  :host([disabled]) .sh-step-thumb-item {
    background: rgba(var(--ui-1), var(--opacity-7));
  }

  :host .markers.step_ticks {
    display: flex;
  }

  :host(:not([show-range])) .markers.step_ticks {
    height: fit-content;
  }

  /* vertical slider */
  :host([vertical]) .vertical-slider-wrapper {
    width: 2rem;
    height: calc(100% - 1.5rem);
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  :host([vertical]) .vertical-wrapper {
    transform: rotate(90deg);
    display: flex;
    width: fit-content;
    align-items: center;
  }

  /* tab-outline */
  :host .tab_outline::-webkit-slider-thumb {
    outline: var(--focus-outline);
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host .tab_outline::-moz-range-thumb {
    outline: var(--focus-outline);
    background: rgba(var(--ui-2), var(--opacity-1));
  }

  :host(:not([show-value])) .tab_tooltip#sliderTooltip,
  :host(:not([show-value])) .tab_tooltip#verticalTooltip {
    display: block;
  }

  :host([vertical]) .textbox_click#verticalMax {
    visibility: hidden;
    width: 0%;
  }

  :host([vertical]) .text_align#verticalInput {
    text-align: center;
  }
`;
